export default { sha: '8605c5097b2227f6080d330b6887e13db93475cd', buildNumber: 'undefined' }
